import { ScriptPage } from '../script-editor/script-page';
import { AdminBookerLeague } from './components/booker-leagues/admin-booker-leagues';
import { AdminCustomerRule } from './components/customer-rule/customer-rule';
import AdminSnoozeConfig from './components/snooze-config/admin-snooze-config';
import { AdminSlotConfig } from './components/slot-config/admin-slot-config';

export const adminSections = [
  { path: 'customer-journey-planner', label: 'Customer Journey Planner', element: <AdminCustomerRule /> },
  { path: 'scripts', label: 'Scripts', element: <ScriptPage /> },
  { path: 'snooze-config', label: 'Snooze Config', element: <AdminSnoozeConfig /> },
  { path: 'booker-leagues', label: 'Booker Leagues', element: <AdminBookerLeague /> },
  { path: 'appointment-limit', label: 'Appointment Limit', element: <AdminSlotConfig /> },
] as const;
